/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ApplicationSubmissionMethod {
  MANUAL = 'MANUAL',
  PDF = 'PDF',
  BULK_CSV = 'BULK_CSV',
  SELF_ENROLLED = 'SELF_ENROLLED',
  DEEPLINK = 'DEEPLINK',
  ENROLL_CONNECT = 'ENROLL_CONNECT',
  OSCAR = 'OSCAR',
}
